import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";
import { TooltipProvider } from "./components/ui/tooltip";
import { LaunchDarklyProvider } from "./integrations/launch-darkly/LaunchDarklyProvider";
import { dropUnactionableErrors } from "./shared/services/ErrorReporting";
import "./shared/i18n";

import "./index.css";

const sentryEnvironment = import.meta.env.VITE_ENVIRONMENT;

if (
  import.meta.env.PROD &&
  sentryEnvironment &&
  import.meta.env.VITE_SENTRY_DSN &&
  import.meta.env.VITE_USE_FIREBASE_EMULATOR !== "true"
) {
  import("@sentry/react").then((Sentry) => {
    Sentry.init({
      dsn: import.meta.env.VITE_SENTRY_DSN,
      environment: sentryEnvironment,
      release: import.meta.env.VITE_APP_VERSION,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
      ],
      tracesSampleRate: sentryEnvironment === "production" ? 0.1 : 1.0,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      beforeSend: dropUnactionableErrors,
    });
  });
}

const root = ReactDOM.createRoot(document.getElementById("root")!);

root.render(
  <React.StrictMode>
    <LaunchDarklyProvider>
      <TooltipProvider delayDuration={100}>
        <App />
      </TooltipProvider>
    </LaunchDarklyProvider>
  </React.StrictMode>,
);
